// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"21":"a860488c","146":"7550c47d","549":"e5f13caf","587":"e1b7839b","633":"25744c21","827":"d0eb7e82","979":"e78cd1a4"}[chunkId] + ".chunk.css";
};